import { getCsrfValue } from "~/common/utils/ApiHelper";

import { resolveApiUrl } from "~/utils/url/urlResolver";

const apiUrl = resolveApiUrl("/cart/sales-partner");

export const updateSalesPartner = (subsidiaryId: string) => {
  return fetch(apiUrl, {
    body: JSON.stringify(subsidiaryId),
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    method: "PATCH",
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response;
    }
  });
};
